import { Hydratable } from "../models/hydration/Hydratable";
import * as StoreIdDecorator from "./StoreIdDecorator";

// let _perf_getObjectStoreId = 0;
// let _perf_getObjectStoreIdString = 0;

const getObjectStoreId = (value: any): any => {
  // var t0 = performance.now()
  const keyProperty: string = StoreIdDecorator.getStoreIdProperty(value);
  const key: any = value[keyProperty];
  // _perf_getObjectStoreId += performance.now() - t0;
  return key;
};

const getObjectStoreIdString = (value: any): string => {
  // var t0 = performance.now()
  let storeId;
  if (Object.keys(value).includes("_hydrated")) {
    if (!Object.keys(value).includes("_storeId")) {
      throw new Error(
        "Cannot get StoreId from Hydrated object without storeId",
      );
    }
    const obj = value as Hydratable<any>;
    storeId = obj._storeId;
  } else {
    storeId = getObjectStoreId(value);
  }
  const ret = JSON.stringify(storeId, null, 0);
  // _perf_getObjectStoreIdString += performance.now() - t0;
  return ret;
};

const stringifyKey = (storeId: any): string => JSON.stringify(storeId, null, 0);

const stringifyModelKey = (modelKey: any): string => {
  if (!modelKey) return "";
  const name = typeof modelKey === "string" ? modelKey : (modelKey.name ?? "");
  const bci = typeof modelKey === "object" && modelKey !== null ? (modelKey.batchClassIdentifier ?? "") : "";
  if (name === "") return "";
  return `${bci}::${name}`;
};

export { getObjectStoreId, getObjectStoreIdString, stringifyKey, stringifyModelKey };

